'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setup = setup;

var _hearbeat = require('./hearbeat');

var _tracking = require('./tracking');

var _getInstanceProperties = require('./getInstanceProperties');

function setup(baseUrl) {
  (0, _hearbeat.heartbeat)(baseUrl + 'api/tracking/heartbeat/');
  window.track = (0, _tracking.tracking)(baseUrl + 'api/games/tracking/');
  window.track('init');
  return (0, _getInstanceProperties.getInstanceProperties)(baseUrl + 'api/games/');
}


//////////////////
// WEBPACK FOOTER
// ./~/dooh-utils/dist/defaultSetup.js
// module id = 144
// module chunks = 0